import { computed, ref } from 'vue'
import { defineStore } from 'pinia'
import formatPhone from 'src/functions/formatPhone'
import type {
  DoctorAppointmentFormProps,
} from 'src/components/pages/appointment/vrach/new/components/DoctorAppointmentForm/types'

/**
 * lpuData формы врача + поле услуги: есть ли ЭЗ на диагностику.
 * Для doctor-формы `hasAppointmentServiceExpress` не передаётся.
 */
type AppointmentLpuData = DoctorAppointmentFormProps['lpuData'] & {
  hasAppointmentServiceExpress: boolean
}

const useLpuDataStore = defineStore('lpuDataStore', () => {
  const lpuData = ref<AppointmentLpuData>({
    id: null,
    name: '',
    phone: '',
    address: '',
    schedule: {},
    townName: '',
    townTimeDelta: 0,
    nearestAppointmentExpress: '',
    hasAppointmentServiceExpress: false,
  })

  const phonePublic = computed(() => (
    lpuData.value.phone
      ? formatPhone({
        phone: lpuData.value.phone,
        country: { iso: window.COUNTRY_DATA.iso },
      })
      : ''
  ))
  const phoneRaw = computed(() => (
    lpuData.value.phone
      ? formatPhone({
        phone: lpuData.value.phone,
        country: { iso: window.COUNTRY_DATA.iso },
        isRaw: true,
      })
      : ''
  ))
  const isTelemedMedical = computed(() => lpuData.value.telemedContractType === 'telemed_medical')

  return {
    lpuData,
    phonePublic,
    formattedLpuPhone: phonePublic,
    phoneRaw,
    isTelemedMedical,
  }
})

export default useLpuDataStore
